var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4719 20.8596C28.2642 20.8596 28.061 20.8782 27.8628 20.9122C27.8826 20.7045 27.8936 20.4941 27.8936 20.2813C27.8936 16.6346 24.9374 13.6783 21.2907 13.6783C17.8017 13.6783 14.947 16.3848 14.706 19.8124C14.1591 19.5612 13.5512 19.4203 12.91 19.4203C10.5294 19.4203 8.59961 21.3501 8.59961 23.7307C8.59961 26.1113 10.5294 28.0411 12.91 28.0411H28.4719C30.455 28.0411 32.0627 26.4335 32.0627 24.4504C32.0627 22.4672 30.455 20.8596 28.4719 20.8596Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4249 8.9809C4.27055 9.6947 6.74437 10.0878 9.39041 10.0878C12.0364 10.0878 14.5103 9.6947 16.3559 8.9809C17.829 8.41119 18.7808 7.64627 18.7808 7.03203C18.7808 6.41804 17.829 5.65312 16.3559 5.0834C14.5103 4.3696 12.0364 3.9765 9.39041 3.9765C6.74437 3.9765 4.27055 4.3696 2.4249 5.0834C0.95181 5.65312 0 6.41804 0 7.03203C0 7.64627 0.95181 8.41119 2.4249 8.9809Z",
    fill: "#3A57FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4249 16.2021C4.27055 16.9159 6.74437 17.309 9.39041 17.309C10.8297 17.309 12.2177 17.1923 13.4817 16.9714C13.9391 15.8917 14.6201 14.909 15.4961 14.0888C16.4442 13.2009 17.5668 12.5534 18.7808 12.1779V9.85889C18.2884 10.1801 17.7045 10.4736 17.0335 10.7332C14.977 11.5284 12.2627 11.9665 9.39041 11.9665C6.51835 11.9665 3.80382 11.5284 1.74731 10.7332C1.07632 10.4736 0.492417 10.1801 0 9.85889V14.2532C0 14.8674 0.95181 15.6324 2.4249 16.2021Z",
    fill: "#3A57FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71575 19.1837C6.0954 19.1206 3.64212 18.6915 1.74731 17.9586C1.07632 17.6991 0.492417 17.4058 0 17.0844V21.4789C0 22.0929 0.95181 22.8578 2.4249 23.4276C3.64017 23.8975 5.12769 24.2284 6.75709 24.3997C6.73337 24.1798 6.72089 23.9567 6.72089 23.7304C6.72089 21.9346 7.48997 20.3153 8.71575 19.1837Z",
    fill: "#3A57FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0626,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage1);
export default __webpack_public_path__ + "static/media/Storage 1.3500d485a0abea91b1b83f6d1f87e13d.svg";
export { ForwardRef as ReactComponent };